import { combineReducers } from '@reduxjs/toolkit'

import authSlice from "./auth.slice";
import chartSlice from "./chart.slice";
import loaderSlice from './loader.slice';

const rootReducer = combineReducers({
  loader: loaderSlice,
  auth: authSlice,
  chart: chartSlice
})

export default rootReducer